module.exports = __webpack_public_path__ + "static/media/kouiShitagi.6f492e23.png";